const ErrorType = {
  PAGE_NOT_FOUND: 'PAGE_NOT_FOUND',
  OTHER: 'OTHER',
};

export {
  ErrorType,
};
